import { useMemo } from "react"
import ReactSelect from "react-select"
import { FiPlay, FiCheck, FiPause } from "react-icons/fi"
import useT from "utils/hooks/useT"

export default function TaskStatePicker({ required, disabled, value, onChange }) {
  const { t } = useT("common")
  const taskStateOptions = useMemo(
    () => [
      { label: <>{t("notStarted")}</>, value: "NOT_STARTED" },
      {
        label: (
          <>
            {t("started")}
            <FiPlay />
          </>
        ),
        value: "STARTED",
      },
      {
        label: (
          <>
            {t("paused")}
            <FiPause />
          </>
        ),
        value: "PAUSED",
      },
      {
        label: (
          <>
            {t("finished")}
            <FiCheck />
          </>
        ),
        value: "STOPPED",
      },
    ],
    [t]
  )
  const taskStateValue = taskStateOptions.find((item) => item.value === value)
  if (required && !taskStateValue) {
    throw new Error("TaskStatePicker received an invalid value")
  }
  return (
    <ReactSelect
      className="TaskStatePicker"
      classNamePrefix="TaskStatePicker"
      placeholder={t("selectState")}
      isClearable={false}
      isDisabled={disabled}
      options={taskStateOptions}
      onChange={({ value }) => onChange(value)}
      value={taskStateValue}
      menuPosition="absolute"
    />
  )
}
